import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { GeoLockProfileDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { GeoLockProfileCreateRequest, GeoLockProfileResponse, GeoLockProfileUpdateRequest } from '@key-telematics/fleet-api-client';

@RegisterEntityHandler('geolockprofile')
@Injectable()
export class GeoLockProfileHandler extends EntityHandler<GeoLockProfileResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    states = ['active', 'deleted'];

    async listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listGeoLockProfiles/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listGeoLockProfiles(ownerId, false, offset, limit, sort, filter), 3).then((response: EntityListResult) => ({
            ...response,
            type: 'geolockprofile',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.GEOLOCKPROFILES'),
        }));
    }

    getEntity(id: string): Promise<GeoLockProfileResponse> {
        return this.admin.getCached(`getGeoLockProfile/${id}`, api => api.entities.getGeoLockProfile(id), 10);
    }

    createEntity(ownerId: string, entity: GeoLockProfileCreateRequest): Promise<GeoLockProfileResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createGeoLockProfile(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateGeoLockProfile(entity.id, { state: state as any }));
    }

    getGridIcon(item: GeoLockProfileResponse): string {
        return item.times && item.times.length > 0 ? ICONS.geolockprofile : 'exclamation-triangle';
    }

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.GEOLOCKPROFILE.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', this.getGridIcon),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<GeoLockProfileResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new GeoLockProfileDetailsSectionHandler(this.admin, ownerId, false),
            ].filter(x => x),
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: GeoLockProfileUpdateRequest, sections: FormSectionHandler<GeoLockProfileResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'geolockprofile',
            entity: {}, // set up some defaults if you want
            sections: [
                new GeoLockProfileDetailsSectionHandler(this.admin, ownerId, true),
            ],
        });
    }

}












